/**
 * settingsUi.js — Adapted for RaceProX
 *
 * Panel toggle/collapse logic for edit mode.
 * In display mode, both panels are hidden (done by bootstrap/main).
 */
import { mountPanelToggles } from './mountPanelToggles.jsx';

function syncSettingsPanelLayout() {
  const header = document.getElementById('venue-header');
  if (!header) return;
  const { bottom, left } = header.getBoundingClientRect();
  document.documentElement.style.setProperty('--venue-header-bottom', `${bottom}px`);
  document.documentElement.style.setProperty('--venue-header-left', `${left}px`);
}

syncSettingsPanelLayout();
window.addEventListener('resize', syncSettingsPanelLayout);

const venueHeader = document.getElementById('venue-header');
if (venueHeader && typeof ResizeObserver !== 'undefined') {
  const headerObserver = new ResizeObserver(syncSettingsPanelLayout);
  headerObserver.observe(venueHeader);
}

const userPanel = document.getElementById('user-panel');
const adminPanel = document.getElementById('admin-panel');
const userBody = document.getElementById('user-panel-body');
const adminBody = document.getElementById('admin-panel-body');

mountPanelToggles();

function wireAdminSectionCollapse() {
  if (!adminPanel) return;
  adminPanel.querySelectorAll('.settings-section').forEach((section) => {
    const heading = section.querySelector(':scope > h3');
    if (!heading) return;

    section.classList.add('is-section-collapsed');
    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-expanded', 'false');

    const toggle = () => {
      const collapsed = section.classList.toggle('is-section-collapsed');
      heading.setAttribute('aria-expanded', String(!collapsed));
    };

    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      toggle();
    });
  });
}

wireAdminSectionCollapse();

function isAdminVisible() {
  return adminPanel && !adminPanel.classList.contains('is-panel-hidden');
}

function setAdminVisible(showAdmin) {
  if (!userPanel || !adminPanel) return;
  userPanel.classList.toggle('is-panel-hidden', showAdmin);
  adminPanel.classList.toggle('is-panel-hidden', !showAdmin);
  userPanel.hidden = showAdmin;
  adminPanel.hidden = !showAdmin;
  document.body.classList.toggle('is-admin-mode', showAdmin);
}

function toggleAdminPanel() {
  setAdminVisible(!isAdminVisible());
}

/**
 * Hide all panels — used in display mode.
 */
export function hideAllPanels() {
  if (userPanel) {
    userPanel.classList.add('is-panel-hidden');
    userPanel.hidden = true;
  }
  if (adminPanel) {
    adminPanel.classList.add('is-panel-hidden');
    adminPanel.hidden = true;
  }
}

/**
 * Show panels for edit mode.
 */
export function showEditPanels() {
  if (userPanel) {
    userPanel.classList.remove('is-panel-hidden');
    userPanel.hidden = false;
  }
  if (adminPanel) {
    adminPanel.classList.add('is-panel-hidden');
    adminPanel.hidden = true;
  }
}

document.addEventListener('keydown', (e) => {
  if (!e.metaKey || e.key.toLowerCase() !== 'a') return;
  const t = e.target;
  if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement || t instanceof HTMLSelectElement) {
    return;
  }
  if (t && 'isContentEditable' in t && t.isContentEditable) return;
  e.preventDefault();
  toggleAdminPanel();
});

document.querySelectorAll('#admin-panel input[type="range"][data-setting]').forEach((input) => {
  const key = input.dataset.setting;
  const output = document.querySelector(`#admin-panel output[data-for="${key}"]`);

  const syncOutput = () => {
    if (output) output.textContent = input.value;
  };

  input.addEventListener('input', syncOutput);
  syncOutput();
});
